import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faWallet } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'

const DeleteCard = ({cardName, cardAccount}) => {
    return (
        <BaseModal modalId="modalDeleteCard" modalTitle="Delete Card" modalTitleIcon={faWallet}>
            <div className="text-dark">
                <div>
                    Card: {cardName}
                </div>
                <div>
                    Account Number: {cardAccount}
                </div>
                <FontAwesomeIcon icon={faTrashAlt} className="text-danger h3" />
            </div>
        </BaseModal>
    )
}

export default DeleteCard